import React  from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@carbon/react';

import styles from './filter.module.scss';
import cx from 'classnames';

export const FilterItem = ({
  id,
  name,
  label = 'LABEL',
  checked = false,
  onChange,
  disableCount,
  rightText,
}) => {
  return (
    <div className={cx(styles.item)} key={`filter_item_${id}`}>
      <Checkbox
        name={`filter_item_${name}_${id}`}
        labelText={label}
        id={`filter_item_${name}_${id}`}
        onChange={(_,{checked}) => {
          onChange(id, checked);
        }}
        checked={checked}
        disabled={!disableCount && (rightText < 1)}
      />
      {disableCount || <span>{rightText || 0}</span>}
    </div>
  )
};

FilterItem.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  checked: PropTypes.bool,
  rightText: PropTypes.string,
  onChange: PropTypes.func,
};

